// Holds a reference to notistack's enqueueSnackbar so it can be called outside React.
// setSnackbarRef is called in App.js via SnackbarConfigurator, and showSnackbar is used
// by the axios response interceptor in API.js to auto-display critical error snackbars.
let snackbarRef = null;

export const setSnackbarRef = (ref) => {
  snackbarRef = ref;
};

export const showSnackbar = (message, options) => {
  if (snackbarRef) {
    snackbarRef(message, options);
  }
};
